"use client";

import { ChakraProvider, defaultSystem } from "@chakra-ui/react";
import { ColorModeProvider } from "./color-mode";

/**
 * @typedef {object} Props
 * @prop {import("@chakra-ui/react").SystemContext} [system]
 * @prop {boolean} [withColorModeProvider]
 */
/**
 * @param {Props & import("next-themes").ThemeProviderProps} props
 */
export function Provider({
  system,
  withColorModeProvider,
  children,
  ...others
}) {
  return (
    <ChakraProvider value={system ?? defaultSystem}>
      {withColorModeProvider ? (
        <ColorModeProvider
          enableSystem={false}
          children={children}
          {...others}
        />
      ) : (
        children
      )}
    </ChakraProvider>
  );
}
